import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactory,
  ComponentRef,
  Input,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { FormGroup, FormGroupDirective } from "@angular/forms";
import { DynamicInputComponent } from "../dynamic-input/dynamic-input.component";
import { DynamicSelectComponent } from "../dynamic-select/dynamic-select.component";
import { DynamicRadioComponent } from "../dynamic-radio/dynamic-radio.component";
import { DynamicCheckboxsComponent } from "../dynamic-checkboxs/dynamic-checkboxs.component";
import { DynamicFormModel, SupportedModel } from "../../models/dynamic-form-model";
import { DynamicToggleComponent } from '../dynamic-toggle/dynamic-toggle.component';
@Component({
  selector: 'ebw-monorepo-field-input',
  templateUrl: './field-input.component.html',
  styleUrls: ['./field-input.component.scss']
})
export class FieldInputComponent implements AfterViewInit {
  supportedDynamicComponents: SupportedModel[] = [
    {
      name: 'text',
      component: DynamicInputComponent
    },
    {
      name: 'number',
      component: DynamicInputComponent
    },
    {
      name: 'select',
      component: DynamicSelectComponent
    },
    {
      name: 'radio',
      component: DynamicRadioComponent
    },
    {
      name: 'date',
      component: DynamicInputComponent
    },
    {
      name: 'date_range',
      component: DynamicInputComponent
    },
    {
      name: 'checkbox',
      component: DynamicCheckboxsComponent
    },
    {
      name: 'toggle',
      component: DynamicToggleComponent
    }
  ]
  @ViewChild('dynamicInputContainer', { read: ViewContainerRef }) dynamicInputContainer!: ViewContainerRef;
  @Input() field: DynamicFormModel;
  formName: FormGroup;
  constructor(private formgroupDirective: FormGroupDirective, private cd: ChangeDetectorRef) {
  }
  ngAfterViewInit(): void {
    this.registerDynamicField();
  }
  getComponentByType(type: string): any {
    const componentDynamic = this.supportedDynamicComponents.find(c => c.name === type);
    return componentDynamic.component || DynamicInputComponent;
  }
  private registerDynamicField() {
    this.dynamicInputContainer.clear();
    const componentInstance = this.getComponentByType(this.field.type) //as ComponentFactory<any>;
    const dynamicComponent = this.dynamicInputContainer.createComponent(componentInstance) as ComponentRef<any>;
    dynamicComponent.instance.field = this.field;
    this.cd.detectChanges();
  }
}
